import { createSlice } from '@reduxjs/toolkit'

export const PendingReducer = createSlice({
    name: 'pendingData',
    initialState: {
        PendingData: null,
    },
    reducers: {
        setPendingData: (state, action) => {
            state.PendingData = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { setPendingData } = PendingReducer.actions

export default PendingReducer.reducer